/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  manufacturerIdLabel,
  nameLabel,
  rebateProgramLabel,
  quarterRangeLabel,
  unallocatedBalanceLabel,
  URAUsedLabel,
  ARmanufacturerLabel,
} from './ConstantData';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { ARManufacturerColumns } from '../tablehead';
import ActionDropDownComp from '../ActionDropdownComp';
import * as actiontype from './store/actiontypes';
import ModalDialog from '../../../../SharedModules/Dialog/ModalDialog';
import CommonModal from '../../../../SharedModules/Dialog/CommonModal';
import * as AR_CONST from '../AccountsRevConstants';
import {
  arMfgFirstLoadAction,
  arMfgTblData,
  getAccRecNDCSingleRec,
  getUnallocatedMfgAr,
} from './store/actions';
import {
  getExistingCorrLinkIds,
  getInvoiceDetails,
  updateInvoiceBalanced,
  undoInvoiceBalanced,
  updateInvoiceBankrupt,
  undoInvoiceBankrupt,
  goToArSummaryAccRecNDCSingle,
} from '../ARCommonFunctions';
import {
  getAccRecNDCSingleDetail,
  singleAccRecNDCData,
} from '../QtrAccountsRec/store/actions';
import CommentIcon from '../../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../../assets/images/commen-visible-icon.svg';
import RedTextRenderComp from '../RedTextRenderComp';
import { compareQtrs } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  ndcDetailSingle,
  dispatchNDCBalanceDue,
  dispatchNDCOveridden,
  dispatchNDCPaidInFull,
  ndcDetailFirstLoadAction,
} from '../AccRecNDCDetail/store/actions';
import { checkNumber } from '../../../../SharedModules/utilities/utilities';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';

const ARManufacturer = (props) => {
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [pinned, setPinned] = React.useState([]);
  const [load, setLoad] = React.useState(false);
  const [showComments, setShowComments] = React.useState(false);
  const [confimPopup, setConfimPopup] = React.useState(false);
  const [confirmPopupData, setConfirmPopupData] = React.useState({
    callFrom: '',
    popupText: '',
  });
  const [undoData, setUndoData] = React.useState({});
  const [corrLinkId, setCorrLinkId] = React.useState('');
  const [isDialogOpen, setIsDialogOpen] = React.useState(false);
  const [dialogText, setDialogText] = React.useState(false);

  const { ar_manu_fld, ar_manu_tbl, unallocated, ndc_data, arMfgFirstLoad } =
    useSelector((state) => state?.sharedState?.ARManufacturerReducer);

  const { rbt_list } = useSelector(
    (state) => state?.sharedState?.AccountRecReducer
  );
  const getSingleAccRecNDCList = useSelector(
    (state) => state?.sharedState?.QtrAccountsRecReducer?.getSingleAccRecNDCList
  );
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  // get single NDC detail list and redirect NDC detail single page
  React.useEffect(() => {
    if (getSingleAccRecNDCList && getSingleAccRecNDCList.status === '001') {
      goToArSummaryAccRecNDCSingle(props.history, ar_manu_fld.pgmCd, dispatch);
      dispatch(ndcDetailFirstLoadAction(false));
      if (UserDefaultValues) {
        if (UserDefaultValues?.dispBalanceDueNdcInd != 0)
          dispatch(dispatchNDCBalanceDue(true));
        else dispatch(dispatchNDCBalanceDue(false));
        if (UserDefaultValues?.dispOverriddenNdcInd != 0)
          dispatch(dispatchNDCOveridden(true));
        else dispatch(dispatchNDCOveridden(false));
        if (UserDefaultValues?.dispPaidInFullNdcInd != 0)
          dispatch(dispatchNDCPaidInFull(true));
        else dispatch(dispatchNDCPaidInFull(false));
      }
      dispatch(singleAccRecNDCData([]));
    }
  }, [getSingleAccRecNDCList]);
  const onGridReady = (params) => {
    setGridApi(params);
  };

  const getBgHighlighterColor = (obj) => {
    let bgColor = '';
    if (
      obj.invoiceStatus === 'DB' ||
      obj.invoiceStatus === 'FG' ||
      obj.invoiceStatus === 'WO' ||
      obj.invoiceStatus === 'DBK'
    ) {
      bgColor = 'green-legend';
    } else if (obj.actions === 'hide') {
      bgColor = 'd-none';
    } else if (obj.drams && obj.qtr && compareQtrs(obj.drams, obj.qtr)) {
      bgColor = 'yellow-legend';
    }
    return bgColor;
  };

  const commentsCallFn = async () => {
    const val = ar_manu_tbl.infoList.map((o) => o.corrLinkId);
    const result = await dispatch(getExistingCorrLinkIds(val));
    let newVal = ar_manu_tbl.infoList.map((obj) => {
      obj.cc_COMMENTS_EXIST = 0;
      if (result.indexOf(obj.corrLinkId) !== -1) obj.cc_COMMENTS_EXIST = 1;
      return obj;
    });
    newVal = { ...ar_manu_tbl, infoList: newVal };
    dispatch(arMfgTblData(newVal));
    if (gridApi) gridApi.api.redrawRows();
  };

  const commentsData = (status, id) => {
    setShowComments(status);
    setCorrLinkId(id);
  };

  const updateInvoiceBalancedHandler = (data) => {
    setLoad(true);
    getInvoiceDetails(data.data.invoiceNum).then((invDtl) => {
      setLoad(false);
      if (invDtl) {
        if (
          data.data.invoiceStatus === 'DB' ||
          data.data.invoiceStatus === 'DBK'
        ) {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceDeclaredBalancedMsg);
        } else if (!invDtl?.invoiceFreezeDt) {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceFrozen);
        } else if (data.data.invoiceStatus === 'FG') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceIsForgivenMsg);
        } else if (data.data.invoiceStatus === 'WO') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceWrittenOffMsg);
        } else {
          const payloadData = {
            invoiceStatusCd: data.data.invoiceStatus,
            invoiceNum: data.data.invoiceNum,
            rebateProgramCd: ar_manu_fld?.pgmCd,
            invoiceQtr: data.data.qtr,
          };
          updateInvoiceBalanced(payloadData).then((res) => {
            if (res && res.data.status === '001') {
              setIsDialogOpen(true);
              if (res.data.response.invoiceStatus === 'DB') {
                setDialogText(AR_CONST.invoiceBalanceCompleted);
                const updatedStatusData = ar_manu_tbl.infoList.map((item) => {
                  if (item.invoiceNum === data.data.invoiceNum)
                    item.invoiceStatus = 'DB';
                  return item;
                });
                dispatch(
                  arMfgTblData({
                    ...ar_manu_tbl,
                    infoList: updatedStatusData,
                  })
                );
                if (gridApi) gridApi.api.refreshCells();
              } else {
                setDialogText(res.data.response.responseMessage);
              }
            } else {
              setIsDialogOpen(true);
              setDialogText(AR_CONST.invoiceBalanceFailed);
            }
          });
        }
      }
    });
  };

  const undoInvoiceBalancedHandler = (data) => {
    if (data.data.invoiceStatus === 'FG') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoForgivenMsg);
    } else if (data.data.invoiceStatus === 'WO') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoWrittenOff);
    } else if (
      data.data.invoiceStatus !== 'DB' &&
      data.data.invoiceStatus !== 'DBK'
    ) {
      // show confirmation popup
      setConfimPopup(true);
      setConfirmPopupData({
        callFrom: 'balance',
        popupText: AR_CONST.undoDeclareBalanced,
      });
      setUndoData(data);
    } else {
      const payloadData = {
        invoiceStatusCd: data.data.invoiceStatus,
        invoiceNum: data.data.invoiceNum,
        rebateProgramCd: ar_manu_fld?.pgmCd,
        invoiceQtr: data.data.qtr,
      };
      setLoad(true);
      undoInvoiceBalanced(payloadData).then((res) => {
        setLoad(false);
        if (res && res.data.response) {
          // Update table grid store
          const updatedStatusData = ar_manu_tbl.infoList.map((item) => {
            if (item.invoiceNum === data.data.invoiceNum)
              item.invoiceStatus = res.data.response?.invoiceStatus;
            return item;
          });
          dispatch(
            arMfgTblData({
              ...ar_manu_tbl,
              infoList: updatedStatusData,
            })
          );

          if (gridApi) gridApi.api.refreshCells();

          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoDeclareBalancedCompleted);
        } else {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoDeclareBalancedFailed);
        }
      });
    }
  };

  const declareInvoiceBankruptHandler = (data) => {
    setLoad(true);
    getInvoiceDetails(data.data.invoiceNum).then((invDtl) => {
      setLoad(false);
      if (invDtl) {
        if (data.data.invoiceStatus === 'DBK') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceAlreadyBankrupt);
        } else if (!invDtl?.invoiceFreezeDt) {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceBankruptFrozon);
        } else if (data.data.invoiceStatus === 'FG') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceBankruptForgiven);
        } else if (data.data.invoiceStatus === 'WO') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceBankruptWrittenOff);
        } else if (data.data.invoiceStatus === 'DB') {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.invoiceBankruptBalanced);
        } else {
          const payloadData = {
            invoiceStatusCd: data.data.invoiceStatus,
            invoiceNum: data.data.invoiceNum,
            rebateProgramCd: ar_manu_fld?.pgmCd,
            invoiceQtr: data.data.qtr,
          };
          updateInvoiceBankrupt(payloadData).then((res) => {
            if (res && res.data?.status === '001') {
              setIsDialogOpen(true);
              if (res.data?.response?.invoiceStatus === 'DBK') {
                const updatedStatusData = ar_manu_tbl.infoList.map((item) => {
                  if (item.invoiceNum === data.data.invoiceNum)
                    item.invoiceStatus = 'DBK';
                  return item;
                });
                dispatch(
                  arMfgTblData({
                    ...ar_manu_tbl,
                    infoList: updatedStatusData,
                  })
                );

                if (gridApi) gridApi.api.refreshCells();
                setDialogText(AR_CONST.invoiceBankruptCompleted);
              } else {
                setDialogText(res.data?.response?.responseMessage);
              }
            } else {
              setIsDialogOpen(true);
              setDialogText(AR_CONST.invoiceBankruptFailed);
            }
          });
        }
      }
    });
  };

  const undoDeclareInvoiceBankruptHandler = (data) => {
    if (data.data.invoiceStatus === 'FG') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoInvoiceBankruptForgiven);
    } else if (data.data.invoiceStatus === 'WO') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoInvoiceBankruptWrittenOff);
    } else if (data.data.invoiceStatus === 'DB') {
      setIsDialogOpen(true);
      setDialogText(AR_CONST.undoInvoiceBankruptBalanced);
    } else if (data.data.invoiceStatus !== 'DBK') {
      // show confirmation popup
      setConfimPopup(true);
      setConfirmPopupData({
        callFrom: 'bankrupt',
        popupText: AR_CONST.undoInvoiceBankruptConfirmMsg,
      });
      setUndoData(data);
    } else {
      setLoad(true);
      const payloadData = {
        invoiceStatusCd: data.data.invoiceStatus,
        invoiceNum: data.data.invoiceNum,
        rebateProgramCd: ar_manu_fld?.pgmCd,
        invoiceQtr: data.data.qtr,
      };

      undoInvoiceBankrupt(payloadData).then((res) => {
        setLoad(false);
        if (res && res.data?.response) {
          // Update table grid store
          const updatedStatusData = ar_manu_tbl.infoList.map((item) => {
            if (item.invoiceNum === data.data.invoiceNum)
              item.invoiceStatus = res.data.response?.invoiceStatus;
            return item;
          });
          dispatch(
            arMfgTblData({
              ...ar_manu_tbl,
              infoList: updatedStatusData,
            })
          );

          if (gridApi) gridApi.api.refreshCells();

          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoInvoiceBankruptCompleted);
        } else {
          setIsDialogOpen(true);
          setDialogText(AR_CONST.undoInvoiceBankruptFailed);
        }
      });
    }
  };

  const frameworkComponents = {
    ActionRenderer: (cellInfo) => {
      return (
        <>
          <div className="tdCell dib icon-btn-group">
            <OverlayTrigger
              placement="bottom"
              overlay={<Tooltip id="com-tooltip">Comment</Tooltip>}
            >
              <Button
                onClick={() => commentsData(true, cellInfo.data.corrLinkId)}
                variant="text"
                type="button"
                aria-label="comment"
                className="th-ic comment-ic frr-disabled-comment-btn"
              >
                {!cellInfo.data.cc_COMMENTS_EXIST ? (
                  <SVGComponent iconName="Icon-comment-grey" />
                ) : (
                  <SVGComponent iconName="Icon-comment" />
                )}
              </Button>
            </OverlayTrigger>
          </div>
          <ActionDropDownComp
            data={cellInfo}
            loadfn={setLoad}
            displayBy="mfgAr"
            extraData={ar_manu_fld}
            selectPgm={false}
            selectedRebate={() => {}}
            handleGoToAccRecNDCDetail={handleGoToAccRecNDCDetail}
            updateInvoiceBalancedHandler={updateInvoiceBalancedHandler}
            undoInvoiceBalancedHandler={undoInvoiceBalancedHandler}
            declareInvoiceBankruptHandler={declareInvoiceBankruptHandler}
            undoDeclareInvoiceBankruptHandler={
              undoDeclareInvoiceBankruptHandler
            }
          />
        </>
      );
    },
    InvoiceDateRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.value}</b>;
      }
      return cellInfo.value;
    },
    redTextRenderer: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <CustomGridCellRendererComponent {...cellInfo} />;
      }
      return <RedTextRenderComp data={cellInfo} />;
    },
    CheckboxRenderer: (cellInfo) => {
      return (
        <div className="tbl-checkbox">
          <FormControlLabel
            control={<Checkbox color="primary" />}
            value={cellInfo.data.ccLetterSent === 0 ? false : true || false}
            disabled
            onChange={(e, val) => {}}
            checked={cellInfo.data.ccLetterSent === 0 ? false : true || false}
          />
        </div>
      );
    },
  };

  const renderTooltip = (propsTooltip) => {
    return ar_manu_fld?.qtrInfo.indexOf('DRAMS') !== -1 ||
      ar_manu_fld?.qtrInfo.indexOf('First') !== -1 ? (
      <Tooltip id="add-tooltip" {...propsTooltip}>
        {ar_manu_fld.qtrInfo}
      </Tooltip>
    ) : (
      <p {...propsTooltip} />
    );
  };

  const handleGoToAccRecNDCDetail = (row) => {
    if (row) {
      setLoad(true);
      const obj = { ...row.data, ...ar_manu_fld };
      const payload = {
        mfgId: ar_manu_fld.mfgId,
        startQuarter: row.data.qtr,
        aiUseOfficialURA: ar_manu_fld.useOfficialURA,
        invoiceNumber: parseInt(row.data.invoiceNum),
        rebateProgramCd: ar_manu_fld?.pgmCd,
      };
      dispatch(getAccRecNDCSingleDetail(payload));
      dispatch(ndcDetailSingle({ ...row.data, ...ar_manu_fld }));
      //dispatch(getAccRecNDCSingleRec(payload, obj));
    }
  };

  const UserDefaultValues = useSelector(
    (state) => state.sharedState.UserDefaultReducer.UserDefaultsValues.data
  );

  React.useEffect(() => {
    if (ndc_data) {
      if (ndc_data.status === '001' && ndc_data.message === 'SUCESS') {
        goToArSummaryAccRecNDCSingle(
          props.history,
          ar_manu_fld.pgmCd,
          dispatch
        );
        dispatch(ndcDetailFirstLoadAction(false));
        if (UserDefaultValues) {
          if (UserDefaultValues?.dispBalanceDueNdcInd != 0)
            dispatch(dispatchNDCBalanceDue(true));
          else dispatch(dispatchNDCBalanceDue(false));
          if (UserDefaultValues?.dispOverriddenNdcInd != 0)
            dispatch(dispatchNDCOveridden(true));
          else dispatch(dispatchNDCOveridden(false));
          if (UserDefaultValues?.dispPaidInFullNdcInd != 0)
            dispatch(dispatchNDCPaidInFull(true));
          else dispatch(dispatchNDCPaidInFull(false));
        }
        dispatch({ type: actiontype.AR_MFG_NDC_DETAIL, payload: null });
      }
    }
  }, [ndc_data]);
  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  const sum = (property) =>
    filteredRows?.reduce((acc, obj) => acc + obj[property], 0);
  React.useEffect(() => {
    if (!filterApply) {
      const data = [
        {
          origInvoiceAmt: ar_manu_tbl?.totalOrigInvoiceAmount,
          currBalDue: ar_manu_tbl?.totalPrincipalDue,
          offsetDue: ar_manu_tbl?.totalOffsetDue,
          baseStateAmountDue: ar_manu_tbl?.totalBaseStateAmtDue,
          currInvAmt: ar_manu_tbl?.totalCurrentInvoice,
          currRoa: ar_manu_tbl?.totalCurrentRebateOffsetAmount,
          baseStateRebateAmount: ar_manu_tbl?.totalBaseStateRebateAmount,
          amtPaid: ar_manu_tbl?.totalprincipalPaid,
          offsetPaidAmt: ar_manu_tbl?.totaloffSetPaid,
          baseStateAmountPaid: ar_manu_tbl?.totalBaseStateAmountPaid,
          interestPaidAmt: ar_manu_tbl?.totalInterestPaid,
          disputedAmt: ar_manu_tbl?.totalDisputedAmount,
          unpaidAmt: ar_manu_tbl?.totalUnpaidAmont,
          adjustmentAmount: ar_manu_tbl?.totalAdjustmentAmount,
          unitChangeAmt: ar_manu_tbl?.totalUnitChangeAmount,
          interestDue: ar_manu_tbl?.totalInterestDue,
          famPlnAmt: ar_manu_tbl?.totalFamilyPlanningAmount,
          fedAmt: ar_manu_tbl?.totalFederalAmount,
          stateAmount: ar_manu_tbl?.totalStateAmount,
          actions: 'hide',
          invoiceDate: 'Total:',
          isBottomRow: true,
        },
      ];
      setPinned(data);
    } else {
      const data = [
        {
          origInvoiceAmt: sum('origInvoiceAmt'),
          currBalDue: sum('currBalDue'),
          offsetDue: sum('offsetDue'),
          baseStateAmountDue: sum('baseStateAmountDue'),
          currInvAmt: sum('currInvAmt'),
          currRoa: sum('currRoa'),
          baseStateRebateAmount: sum('baseStateRebateAmount'),
          amtPaid: sum('amtPaid'),
          offsetPaidAmt: sum('offsetPaidAmt'),
          baseStateAmountPaid: sum('baseStateAmountPaid'),
          interestPaidAmt: sum('interestPaidAmt'),
          disputedAmt: sum('disputedAmt'),
          unpaidAmt: sum('unpaidAmt'),
          adjustmentAmount: sum('adjustmentAmount'),
          unitChangeAmt: sum('unitChangeAmt'),
          interestDue: sum('interestDue'),
          famPlnAmt: sum('famPlnAmt'),
          fedAmt: sum('fedAmt'),
          stateAmount: sum('stateAmount'),
          actions: 'hide',
          isBottomRow: true,
          invoiceDate: 'Total:',
        },
      ];
      setPinned(data);
    }
  }, [filterApply, filteredRows]);
  React.useEffect(() => {
    if (ar_manu_tbl && ar_manu_fld) {
      setLoad(false);
      if (gridApi) gridApi.api.refreshCells();
      if (!arMfgFirstLoad) {
        dispatch(arMfgFirstLoadAction(true));
        commentsCallFn();
        const [drams] = rbt_list?.filter(
          (obj) => obj.rebateProgramCd === ar_manu_fld.pgmCd
        );
        ar_manu_tbl.infoList.map((obj) => {
          obj.drams = drams.dramsInvoiceStartQtr;
          obj.bgHighlighterColor = getBgHighlighterColor(obj);
          return obj;
        });
      }
    }
  }, [ar_manu_tbl]);

  let firstInfo = `Manufacturer ID: ${ar_manu_fld?.mfgId}`;
  let secondInfo = `Quarter Range: ${ar_manu_fld?.qtrInfo}`;
  let thirdInfo = `Rebate Program: ${ar_manu_fld?.pgmInfo}`;
  let fourthInfo = `Manufacturer Name: ${ar_manu_fld?.mfgName}`;
  let sixthInfo = `Unallocated Balance: ${
    (unallocated!==null && unallocated!==undefined &&unallocated >= 0)
      ? formatter.format(unallocated).replace(/^(\D+)/, '$1 ')
      : `(${formatter.format(-unallocated).replace(/^(\D+)/, '$1 ')})`
  }`;
  let seventhInfo = `URA Used: ${ar_manu_fld?.uraInfo}`;

  return (
    <div
      className="tabs-container ARScreen"
      data-testid="accRec-ar-manufacturer"
    >
      <CustomSeparator
        parent1="Research"
        parent2={`AR Manufacturer ${
          ar_manu_fld?.rebateProgram ? `[${ar_manu_fld.rebateProgram}]` : ''
        }`}
      />
      <div className="row">
        {!fullScreenView && (
          <div className="col-12">
            <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
              <div className="row">
                <div className="col-12 col-sm-4 col-md-4">
                  <div className="mui-custom-form">
                    <TextField
                      id="manufacturerId"
                      label={manufacturerIdLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={ar_manu_fld?.mfgId}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4">
                  <div className="mui-custom-form">
                    <TextField
                      id="name"
                      label={nameLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={ar_manu_fld?.mfgName}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4">
                  <div className="mui-custom-form">
                    <TextField
                      id="rebateProgram"
                      label={rebateProgramLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={ar_manu_fld?.pgmInfo}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12 col-sm-4 col-md-4">
                  <div className="mui-custom-form">
                    <OverlayTrigger
                      data-testid="overlay"
                      placement="top"
                      overlay={renderTooltip}
                    >
                      <TextField
                        id="quarterRange"
                        label={quarterRangeLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={
                          ar_manu_fld?.qtrInfo.indexOf('DRAMS') !== -1 ||
                          ar_manu_fld?.qtrInfo.indexOf('First') !== -1
                            ? `${ar_manu_fld?.qtrInfo?.substring(0, 20)}...`
                            : ar_manu_fld?.qtrInfo
                        }
                      />
                    </OverlayTrigger>
                  </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4">
                  <div className="mui-custom-form">
                    <TextField
                      id="unAllocateBal"
                      label={unallocatedBalanceLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      className={unallocated < 0 ? 'negative-value' : ''}
                      value={
                        (unallocated!==null && unallocated!==undefined &&unallocated >= 0)
                          ? formatter
                              .format(unallocated)
                              .replace(/^(\D+)/, '$1 ')
                          : `(${formatter
                              .format(-unallocated)
                              .replace(/^(\D+)/, '$1 ')})`
                      }
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4">
                  <div className="mui-custom-form">
                    <TextField
                      id="URAUsed"
                      label={URAUsedLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={ar_manu_fld?.uraInfo}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-display-dropdown-cell">
          <TableGridWithFeatures
            data-testid="ar-Manufacturers-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={() => setFullScreenView(!fullScreenView)}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            noGlobalSort
            columnDefs={ARManufacturerColumns}
            rowData={
              ar_manu_tbl?.infoList?.map((obj) => {
                obj.currBalDue = obj.currBalDue
                  ? obj.currBalDue
                  : parseFloat(0).toFixed(2);
                obj.baseStateAmountDue = checkNumber(obj.baseStateAmountDue)
                  ? obj.baseStateAmountDue
                  : parseFloat(0).toFixed(2);
                obj.currInvAmt = obj.currInvAmt
                  ? obj.currInvAmt
                  : parseFloat(0).toFixed(2);
                obj.currRoa = checkNumber(obj.currRoa)
                  ? obj.currRoa
                  : parseFloat(0).toFixed(2);
                obj.baseStateRebateAmount = obj.baseStateRebateAmount
                  ? obj.baseStateRebateAmount
                  : parseFloat(0).toFixed(2);
                obj.paidAmt = obj.paidAmt
                  ? obj.paidAmt
                  : parseFloat(0).toFixed(2);
                obj.offsetPaidAmt = obj.offsetPaidAmt
                  ? obj.offsetPaidAmt
                  : parseFloat(0).toFixed(2);
                obj.baseStateAmountPaid = obj.baseStateAmountPaid
                  ? obj.baseStateAmountPaid
                  : parseFloat(0).toFixed(2);
                obj.interestPaidAmt = obj.interestPaidAmt
                  ? obj.interestPaidAmt
                  : parseFloat(0).toFixed(2);
                obj.disputedAmt = obj.disputedAmt
                  ? obj.disputedAmt
                  : parseFloat(0).toFixed(2);
                obj.unpaidAmt = obj.unpaidAmt
                  ? obj.unpaidAmt
                  : parseFloat(0).toFixed(2);
                obj.adjustmentAmount = obj.adjustmentAmount
                  ? obj.adjustmentAmount
                  : parseFloat(0).toFixed(2);
                obj.unitChangeAmt = obj.unitChangeAmt
                  ? obj.unitChangeAmt
                  : parseFloat(0).toFixed(2);
                obj.interestDue = obj.interestDue
                  ? obj.interestDue
                  : parseFloat(0).toFixed(2);
                obj.famPlnAmt = obj.famPlnAmt
                  ? obj.famPlnAmt
                  : parseFloat(0).toFixed(2);
                obj.fedAmt = obj.fedAmt ? obj.fedAmt : parseFloat(0).toFixed(2);
                obj.stateAmount = obj.stateAmount
                  ? obj.stateAmount
                  : parseFloat(0).toFixed(2);
                return obj;
              }) || []
            }
            info={{
              firstInfo,
              secondInfo,
              thirdInfo,
              fourthInfo,
              sixthInfo,
              seventhInfo,
            }}
            exportFile
            animateRows
            sideBar={false}
            isScrollOn
            fileName={ARmanufacturerLabel}
            navigateToNextCell={navigateToNextCell}
            pinnedBottomRowData={ar_manu_tbl?.infoList ? pinned : undefined}
            tabToNextCell={tabToNextCell}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
            frameworkComponents={frameworkComponents}
            hideColumnsInPdf={AR_CONST.mfgARHideColumnsInPdf}
          />
        </div>
      </div>
      <CommonModal
        open={isDialogOpen}
        className="dialog-420"
        viewAction
        viewHeader
        data-testid="commonModal1"
        okTitle="Ok"
        onOk={() => setIsDialogOpen(false)}
        childrenComponent={dialogText}
        modalTitle="Manufacturer Accounts Receivable"
        onClose={() => {
          setIsDialogOpen(false);
        }}
      />
      <CommonModal
        open={confimPopup}
        className="dialog-420"
        viewAction
        viewHeader
        data-testid="commonModal2"
        onOk={() => {
          setConfimPopup(false);
          if (confirmPopupData?.callFrom === 'balance')
            updateInvoiceBalancedHandler(undoData);
          else declareInvoiceBankruptHandler(undoData);
        }}
        okTitle="Ok"
        onClose={() => setConfimPopup(false)}
        childrenComponent={confirmPopupData?.popupText}
        closeTitle="Cancel"
      />
      {showComments ? (
        <CommentAndCorrespondenceComponent
          setShowComments={() => {
            commentsCallFn();
            commentsData(false, '');
          }}
          linkTableName="INVOICE_HEADER"
          corrLinkId={corrLinkId}
        />
      ) : null}
    </div>
  );
};

export default ARManufacturer;
